module.exports = __webpack_public_path__ + "static/media/zoom-in.8a68146c.svg";